import "@tamagui/polyfill-dev";
import { isServer } from "@tamagui/constants";
import { YStack } from "@tamagui/stacks";
import { useStackedZIndex } from "@tamagui/z-index-stack";
import * as React from "react";
import { createPortal } from "react-dom";
import { getStackedZIndexProps } from "./helpers.mjs";
import { jsx } from "react/jsx-runtime";
const Portal = React.memo(propsIn => {
  if (isServer) return null;
  const {
      host = globalThis.document?.body,
      stackZIndex,
      children,
      ...props
    } = propsIn,
    zIndex = useStackedZIndex(getStackedZIndexProps(propsIn));
  return createPortal(/* @__PURE__ */jsx(YStack, {
    contain: "strict",
    fullscreen: !0,
    position: "fixed",
    maxWidth: "100vw",
    maxHeight: "100vh",
    pointerEvents: "none",
    ...props,
    zIndex,
    children
  }), host);
});
export { Portal };
//# sourceMappingURL=Portal.mjs.map
